import React from 'react'

import { TtIcon } from '@23/ui-react'

import { useAllFeedsGrouped } from '../../../firebase/hooks/useFloor'
import {
  setEditingFeed,
  useEditingMixState,
} from '../../../firebase/hooks/useMixes'
import { posToStyle } from '../../layouts'

import './EmptyMixSlots.scss'

const EmptyMixSlots = () => {
  const editingMix = useEditingMixState()
  const feeds = useAllFeedsGrouped()

  if (!editingMix) return null

  return (
    <>
      {editingMix.feeds.map((f, idx) => {
        // check that slot has been assign and feed exists in room (participant is present)
        if (f.media && feeds[f.media.type].some((ff) => ff.id === f.media?.id))
          return null

        return (
          <button
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
            type="button"
            className="floor-empty-mix-slot"
            style={posToStyle(f, { withAnchor: true })}
            onClick={() => setEditingFeed(idx, 'swap')}
          >
            <div className="floor-empty-mix-slot-placeholder">
              <TtIcon library="one" name="plus" />
            </div>
          </button>
        )
      })}
    </>
  )
}

export { EmptyMixSlots }
